module.exports = __webpack_public_path__ + "static/media/adobe-illustrator.b887e502.svg";